function getChartChoiceLabelTruncated(label, labelMaxLength, amount) {
    let truncatedLabel;
    if(label.length > labelMaxLength) {
        truncatedLabel =  label.substring(0, labelMaxLength) + '...';
    } else {
        truncatedLabel = label
    }
    if(amount) {
        truncatedLabel = truncatedLabel + " (" + amount + ")";
    }
    return truncatedLabel;
}

export function parseSingleChoiceData(data){
    let res = [];
    for ( let propertyName of Object.keys(data)){
        if(propertyName.includes("#")){
            let split = propertyName.split('#');
            let choiceLabel = split[split.length-1];
            let choiceValue = split[split.length-2];
            if (choiceLabel === "NsNr" && window.dknaLabel)
                choiceLabel = window.dknaLabel;
            let tmp = {
                "choiceLabelWithCount" : getChartChoiceLabelTruncated(choiceLabel, 20, data[propertyName]),
                "choiceLabel" : choiceLabel,
                "choiceValue": choiceValue,
                "noOfAnswers" : data[propertyName],
                "remaining" : data["total"] - data[propertyName]
            };
            res.push(tmp);
        }
    }
    return res;
}

export const compareByQuestionChoicesOrder = (questionChoices) => (e1, e2) => {
    if (e1.choiceValue && e1.choiceValue === '999') return 1;
    if (e2.choiceValue && e2.choiceValue === '999') return -1;

    const realIndex1 = questionChoices.findIndex(sel => sel.label === e1.choiceLabel)
    const realIndex2 = questionChoices.findIndex(sel => sel.label === e2.choiceLabel)
    return realIndex1 - realIndex2;
}

export const cleanChoiceValue = (c) => {
    delete c.choiceValue;
    return c;
}

export function parseMatrixData(data){
    let res = [];
    for (let propertyName of Object.keys(data)){
        if(propertyName.includes("|")){
            let split = propertyName.split('|');
            let choiceLabel = split[split.length-1];
            let tmp = {
                "choiceLabel" : choiceLabel
            };
            const options = Array.from(Object.keys(data[propertyName])).sort(function( a , b){
                if(a.split(";;")[0] >  b.split(";;")[0]) return 1;
                if(a.split(";;")[0] <  b.split(";;")[0]) return -1;
                return 0;
            });
            for(let value of options){
                if(value.includes(";")){
                    let valueSplit = value.split(";");
                    let valueName = valueSplit[valueSplit.length-1];
                    tmp[valueName]=data[propertyName][value]
                }
            }
            res.push(tmp)
        }
    }
    return res;
}

export function parseTextChartData(data, wordsMaxCount){
    let res = [];
    for (let propertyName of Object.keys(data)){
        let tmp = {};
        tmp["tag"] = propertyName;
        tmp["weight"]=data[propertyName];
        res.push(tmp);
    }
    res = res.sort((a, b) => a.weight >= b.weight ? 0 : 1);
    res = res.slice(0, wordsMaxCount);
    return res;

}

export const choicesColorsCluster = [
    "#D2B7F9",
    "#D2B7F9",
    "#9DE0D8",
    "#9DE0D8",
    "#FFD166",
    "#FFD166",
    "#FBAC79",
    "#FBAC79",
    "#A5D6FA",
    "#A5D6FA",
    "#9AA5F5",
    "#9AA5F5",
    "#FCE896",
    "#FCE896",
    "#F2768E",
    "#F2768E",
    "#BCE09D",
    "#BCE09D",
    "#C9977D",
    "#C9977D"
];

export const compareByQuestionSelectsOrder = (questionSelects) => (e1, e2) => {
    const realIndex1 = questionSelects.findIndex(sel => sel.label === e1.choiceLabel)
    const realIndex2 = questionSelects.findIndex(sel => sel.label === e2.choiceLabel)
    return realIndex1 - realIndex2;
}

export function matrixAnswersDataToPercent(data, questionSelects, isMultipleMatrix) {
    const parsedData = parseMatrixData(data, questionSelects).sort(compareByQuestionSelectsOrder(questionSelects));
    return parsedData.map((entry, key) => {
        const total = isMultipleMatrix
            ? data[Object.keys(data)[key]].total
            : Object.entries(entry).reduce((total, [key, val]) =>
                key !== "choiceLabel" ? total + val : 0, 0);

        Object.entries(entry).forEach(([key, val]) => {
            if (key !== "choiceLabel") entry[key] = (val/total * 100).toFixed(2);
            if (key !== "choiceLabel") entry[key+"remaining"] = 100 - entry[key];
        });
        entry["choiceLabelWithCount"] = getChartChoiceLabelTruncated(entry["choiceLabel"], 20, total);
        entry["total"] = total;

        return entry;
    });
}

export function recommendedClusteredChartHeight(answerOptionNo, clusterNo, isMobile) {
    const barHeight = !isMobile ? 25 : 30;
    const aproxLegendHeight = 35 * answerOptionNo + 30; // 30px padding
    const gridHeight = answerOptionNo * barHeight * 1.1 * 1.15;
    const calculatedHeight = clusterNo * gridHeight + aproxLegendHeight;

    // min height for chart
    return calculatedHeight > 380 ? calculatedHeight : 380;
}
